// removed by extract-text-webpack-plugin
module.exports = {"flexDash":"Assign__flexDash___Np-0b","showIndicator":"Assign__showIndicator___1aRbv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Assign/Assign.css
// module id = 1008
// module chunks = 0